export default "__VITE_ASSET__C2yn8PJC__"